import GlobalStyle from '~/components/GlobalStyle';

export default GlobalStyle;
